import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { CartProvider } from './context/CartContext'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import ScrollToTop from './components/ui/ScrollToTop'
import FloatingWhatsApp from './components/ui/FloatingWhatsApp'
import FloatingElements from './components/ui/FloatingElements'
import HomePage from './pages/HomePage'
import './index.css'

// Lazy loading des pages pour optimiser le bundle initial
const ReseauxPage = lazy(() => import('./pages/ReseauxPage'))
const BoutiquePage = lazy(() => import('./pages/BoutiquePage'))
const ProductPage = lazy(() => import('./pages/ProductPage'))
const ServicesPage = lazy(() => import('./pages/ServicesPage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))

// Composant de chargement simple (Fallback)
const PageLoader = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center animate-in fade-in duration-500">
    <div className="relative">
      <div className="w-16 h-16 border-4 border-[var(--accent-green)]/20 rounded-full"></div>
      <div className="w-16 h-16 border-4 border-[var(--accent-green)] border-t-transparent rounded-full animate-spin absolute inset-0"></div>
    </div>
    <div className="mt-8 flex flex-col items-center">
      <div className="text-[var(--text-primary)] text-sm font-bold uppercase tracking-[0.2em]">ETCS</div>
      <div className="text-[var(--text-secondary)] text-[10px] uppercase tracking-widest mt-2 opacity-50">
        Optimisation du flux...
      </div>
    </div>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen relative flex flex-col">
            <FloatingElements />
            <Navbar />
            <main className="relative z-10 flex-grow pt-16 sm:pt-20 lg:pt-24">
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/reseaux" element={<ReseauxPage />} />
                  <Route path="/boutique" element={<BoutiquePage />} />
                  <Route path="/boutique/:slug" element={<ProductPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/a-propos" element={<AboutPage />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
            <FloatingWhatsApp />
          </div>
        </BrowserRouter>
      </CartProvider>
    </ThemeProvider>
  )
}

export default App
